var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { ButtonTertiary } from "../";

import "./FinderTabs.scss";

var FinderTabs = (_temp2 = _class = function (_Component) {
    _inherits(FinderTabs, _Component);

    function FinderTabs() {
        var _temp, _this, _ret;

        _classCallCheck(this, FinderTabs);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            index: 0,
            tabs: [],
            tabpanels: []
        }, _this.componentDidUpdate = function (prevProps) {

            if (prevProps.tabIndex !== _this.props.tabIndex) {
                _this.getTabs();
            }

            if (prevProps.tabId !== _this.props.tabId) {
                _this.getTabs();
            }

            if (prevProps.children !== _this.props.children) {
                _this.getTabs();
            }
        }, _this.getTabpanel = function (child, index) {
            var _child$props = child.props,
                id = _child$props.id,
                url = _child$props.url,
                title = _child$props.title,
                children = _child$props.children;


            var tabpanelId = id || "admin-tabs-" + index;
            var tabId = tabpanelId + "-tab";

            return {
                index: index,
                id: tabpanelId,
                labelledby: tabId,
                children: children
            };
        }, _this.getTab = function (child, index) {
            var _child$props2 = child.props,
                id = _child$props2.id,
                url = _child$props2.url,
                title = _child$props2.title,
                children = _child$props2.children;


            var tabpanelId = id || "admin-tabs-" + index;
            var tabId = tabpanelId + "-tab";

            return {
                index: index,
                url: url,
                id: tabId,
                controls: tabpanelId,
                title: title
            };
        }, _this.getTabs = function () {
            var _this$props = _this.props,
                tabIndex = _this$props.tabIndex,
                tabId = _this$props.tabId;


            if (!_this.props.children) {
                return false;
            }

            var tabs = React.Children.toArray(_this.props.children).map(_this.getTab);
            var tabpanels = React.Children.toArray(_this.props.children).map(_this.getTabpanel);

            var tabsById = {};

            tabpanels.map(function (tab) {
                tabsById[tab.id] = tab;
            });

            if (!tabsById) {
                return false;
            }

            // set index by tabId or tabIndex

            var index = tabId && tabsById && tabsById[tabId] && tabsById[tabId].index || tabIndex;

            _this.setState({
                index: index,
                tabs: tabs,
                tabpanels: tabpanels
            });
        }, _this.renderTabpanel = function (tabpanel, index) {
            var id = tabpanel.id,
                labelledby = tabpanel.labelledby,
                children = tabpanel.children;


            var selected = _this.state.index === index;

            return React.createElement(
                "div",
                { className: "admin-finder__tabpanel", role: "tabpanel",
                    id: id,
                    "aria-selected": selected,
                    "aria-labelledby": labelledby },
                children
            );
        }, _this.renderTab = function (tab, index) {
            var id = tab.id,
                controls = tab.controls,
                url = tab.url,
                title = tab.title;


            var selected = _this.state.index === index;

            return React.createElement(ButtonTertiary, { title: title, url: url, id: id, controls: controls, role: "tab", selected: selected, onClick: function onClick(event) {
                    return _this.onSelect(tab, event);
                } });
        }, _this.onSelect = function (tab, event) {
            var id = tab.id,
                index = tab.index;


            _this.setState({
                index: index,
                id: id
            });

            if (_this.props.onSelect) {
                _this.props.onSelect(tab, event);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FinderTabs.prototype.componentDidMount = function componentDidMount() {
        this.getTabs();
    };

    // render

    FinderTabs.prototype.render = function render() {
        var _state = this.state,
            tabs = _state.tabs,
            tabpanels = _state.tabpanels;


        return React.createElement(
            "div",
            { className: "admin-finder__tabs", role: "dialog" },
            React.createElement(
                "nav",
                { className: "nav-tabs" },
                tabs.map(this.renderTab)
            ),
            tabpanels.map(this.renderTabpanel)
        );
    };

    return FinderTabs;
}(Component), _class.defaultProps = {
    tabIndex: 0,
    tabId: undefined
}, _temp2);


export default FinderTabs;